import { getConfig } from './get-config.util';

export function getServerEndpoint(): string | null {
  return getConfig<string>({
    configName: 'api.SERVER_ENDPOINT',
  });
}

export function isSapC4cEnabled(): boolean {
  return getConfig<boolean>({
    configName: 'features.isSapC4cEnabled',
    defaultValue: false,
  });
}

export function getSapC4cBaseUrl(): string {
  return getConfig<string>({
    configName: 'features.sapC4cBaseUrl',
    defaultValue: '',
  });
}

const OIDC_REDIRECT_URI_SETUP_MESSAGE =
  'features.oidcRedirectUri is not configured in overrides.js. ' +
  'Set it to the NICE OAuth redirect URI registered in CXone (e.g. https://sap-nice-adapter.softel.net).';

export function getOidcRedirectUri(): string {
  const configured = getConfig<string>({
    configName: 'features.oidcRedirectUri',
    defaultValue: '',
  });
  const normalized = configured?.trim().replace(/\/+$/, '') ?? '';

  if (!normalized) {
    throw new Error(OIDC_REDIRECT_URI_SETUP_MESSAGE);
  }

  try {
    new URL(normalized);
  } catch {
    throw new Error(`features.oidcRedirectUri in overrides.js is not a valid URL: ${configured}`);
  }

  return normalized;
}

export function getOidcRedirectOrigin(): string {
  return new URL(getOidcRedirectUri()).origin;
}

export function validateRequiredAppConfig(): void {
  getOidcRedirectUri();
}

export function getDefaultAcwTimeout(): number {
  return getConfig<number>({
    configName: 'acw.defaultTimeout',
    defaultValue: 120,
  });
}

export function isDebugLogsEnabled(): boolean {
  return getConfig<boolean>({
    configName: 'features.enableDebugLogs',
    defaultValue: false,
  });
}

export function isCxoneDeepDebugEnabled(): boolean {
  return getConfig<boolean>({
    configName: 'features.enableCxoneDeepDebug',
    defaultValue: false,
  });
}

export function isLifecycleLogsEnabled(): boolean {
  return getConfig<boolean>({
    configName: 'features.enableLifecycleLogs',
    defaultValue: true,
  });
}
